import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

interface CheckboxProps {
  id?: string;
  label?: string;
  error?: string;
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  className?: string;
}

const Checkbox = React.forwardRef<React.ElementRef<typeof CheckboxPrimitive.Root>, CheckboxProps>(
  ({ className, label, error, id = "checkbox", ...props }, ref) => (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <CheckboxPrimitive.Root
          ref={ref}
          id={id}
          className={cn(
            "h-5 w-5 rounded border border-system-titanium",
            "data-[state=checked]:border-system-primary data-[state=checked]:bg-system-primary",
            className
          )}
          {...props}
        >
          <CheckboxPrimitive.Indicator className="flex items-center justify-center text-white">
            <Check className="h-4 w-4" />
          </CheckboxPrimitive.Indicator>
        </CheckboxPrimitive.Root>
        {label && (
          <label htmlFor={id} className="cursor-pointer text-[13px] text-system-disabled pt-[2px]">
            {label}
          </label>
        )}
      </div>
      {error && <p className="text-sm text-system-error">{error}</p>}
    </div>
  )
);

Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export default Checkbox;
